<template>
  <b-dropdown-item
    @click="addToSegment"
  >
    {{ $t('TABLES.PROJECT_USER_NAVS.ADD_SEGMENT') }}
  </b-dropdown-item>
</template>

<script>
import { mapGetters } from "vuex";
import { BULK_ASSIGN_USERS } from "@/core/services/store/project/project_segments.module";

export default {
  name: "AddToSegment",

  props: {
    checkedUsers: { type: Array, required: true },
    segmentChoices: { type: Object, required: true }
  },

  methods: {
    addToSegment: function() {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.ADD_SEGMENT_BULK.TITLE")}`,
        text: `${this.$t("SWEETALERTS.ADD_SEGMENT_BULK.MESSAGE")}`,
        input: 'select',
        inputOptions: this.segmentChoices,
        inputPlaceholder: `${this.$t("SETUP.NAV.SEGMENTS")}`,
        showCancelButton: true,
        confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`,
        inputValidator: (value) => {
          let payload = {
            projectId: this.projectInfo.id,
            segmentId: value,
            users: this.checkedUsers
          };
          this.$store
            .dispatch(BULK_ASSIGN_USERS, payload)
            .then(() => {
              this.alertSuccess();
              this.$emit('users_changed');
            })
            .catch(() => {
              this.alertFailure();
            });
        }
      })
    },
    alertSuccess: function() {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.ADD_SEGMENT_BULK_SUCCESS.TITLE")}`,
        text: `${this.$t("SWEETALERTS.ADD_SEGMENT_BULK_SUCCESS.MESSAGE")}`,
        icon: 'success',
        confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
      })
    },
    alertFailure: function() {
      this.$swal.fire({
        title: `${this.$t("SWEETALERTS.ADD_SEGMENT_BULK_FAIL.TITLE")}`,
        text: `${this.$t("SWEETALERTS.ADD_SEGMENT_BULK_FAIL.MESSAGE")}`,
        icon: 'error',
        confirmButtonText: `${this.$t("GENERAL.TEXT.CONFIRM")}`
      })
    }
  },

  computed: {
    ...mapGetters(["projectInfo"]),
  }
};
</script>
